import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useGetAllPartnersQuery,useGetAllWorkspacesMutation,useEnablePartnerWithSubUsersMutation,useTogglePartnerAiSuperSearchMutation,useLazyGetPartnerAiSuperSearchQuery } from 'services/user-service';
import Search from '../../../layout/MainLayout/Header/HeaderContent/Search';
import {
    Box,
    Link,
    Table,
    TableSortLabel,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Button,
    Tooltip,
    Typography
} from '@mui/material';
import { visuallyHidden } from '@mui/utils';
import GlobalStyles from '@mui/material/GlobalStyles';
import LoaderCircle from 'components/LoaderCircle';
import { useDispatch, useSelector } from 'react-redux';
import { setPartnerUsers, setUserType } from 'store/reducers/users';
import ActionMenu from 'components/Menu';
import { useDisableUserMutation, useEnableUserMutation, useLazyGetUserAuthTokenQuery } from 'services/auth-service';
import CustomCheckbox from 'pages/components/campaign/CustomCheckbox';
import PlanSetting from 'pages/components/planSettings/PlanSetting';
import toast from 'react-hot-toast';
import ChangePassword from 'pages/user/users/ChangePassword';
import PlanSelector from './PlanSelector';
import AddOnSettingModel from './addOnSettingModel'
import ConfirmStatusDialog from './ConfirmStatusDialog';
import Popover from '@mui/material/Popover';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

function createData(email, name, plan, managePlan, warmupTag, freeTrialExpiresAt, createdAt, lastLogout, status, action, id, EarlyBirdPlan, isPartner, isPartnerSubUser,
    workspace, deletedBy, userDeletedDetails) {
    return {
        email,
        name,
        plan,
        managePlan,
        warmupTag,
        freeTrialExpiresAt,
        createdAt,
        lastLogout,
        status,
        action,
        id,
        EarlyBirdPlan,
        isPartner,
        isPartnerSubUser,
        workspace,
        deletedBy,
        userDeletedDetails
    };
}

function descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
}

function getFormaDate(dateTimeString) {
    const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
    ];
    const date = new Date(dateTimeString);
    const formattedDate = `${monthNames[String(date.getMonth())]} ${String(
        date.getDate()
    ).padStart(2, '0')}, ${date.getFullYear()}`;
    return formattedDate;
}

function getComparator(order, orderBy) {
    return order === 'desc'
        ? (a, b) => descendingComparator(a, b, orderBy)
        : (a, b) => -descendingComparator(a, b, orderBy);
}

function stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) {
            return order;
        }
        return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
}

const headCells = [
    {
        id: 'email',
        align: 'left',
        disablePadding: false,
        label: 'E-MAIL',
    },
    {
        id: 'name',
        align: 'left',
        disablePadding: true,
        label: 'NAME',
    },
    {
        id: 'assignPlan',
        align: 'center',
        disablePadding: true,
        label: 'ASSIGN PLAN',
    },
    {
        id: 'manageSubscription',
        align: 'center',
        disablePadding: true,
        label: 'MANAGE SUBSCRIPTION'
    },
    {
        id: 'freeTrialExpiry',
        align: 'center',
        disablePadding: true,
        label: 'EXPIRY DATE'
    },
    {
        id: 'createdAt',
        align: 'left',
        disablePadding: false,
        label: 'CREATED AT',
    },
    {
        id: 'lastLogout',
        align: 'left',
        disablePadding: false,
        label: 'LAST LOGOUT',
    },
    {
        id: 'deleteBy',
        align: 'center',
        disablePadding: false,
        label: 'DELETED BY ',
    },
    {
        id: 'status',
        align: 'left',
        disablePadding: false,
        label: 'STATUS',
    },
    {
        id: 'aiSuperSearch',
        align: 'center',
        disablePadding: false,
        label: 'SUPER SEARCH',
    },
    {
        id: 'changepassword',
        align: 'cener',
        disablePadding: false,
        label: 'Change Password',
    },
    {
        id: 'action',
        align: 'center',
        disablePadding: false,
        label: 'ACTION',
    },
    {
        id: 'delete',
        align: 'center',
        disablePadding: false,
        label: 'DELETE',
    }
];


function OrderTableHead({ order, orderBy, onRequestSort }) {
    const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
    };
    return (
        <TableHead>
            <TableRow>
                {headCells.map((headCell) => (
                    <TableCell
                        key={headCell.id}
                        align={headCell.align}
                        padding={headCell.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === headCell.id ? order : false}
                        sx={{
                            backgroundColor: 'rgb(242, 244, 246)',
                            color: 'rgb(40, 40, 123)',
                            fontSize: '13',
                            fontWeight: '500',
                        }}
                    >
                        {headCell.id !== 'action' &&
                            headCell.id !== 'warmupTag' &&
                            headCell.id !== 'plan' &&
                            headCell.id !== 'managePlan' &&
                            headCell.id !== 'appSumo' ? (
                            <TableSortLabel
                                active={orderBy === headCell.id}
                                direction={orderBy === headCell.id ? order : 'asc'}
                                onClick={createSortHandler(headCell.id)}
                            >
                                {headCell.label}
                                {orderBy === headCell.id && (
                                    <Box component="span" sx={visuallyHidden}>
                                        {order === 'desc'
                                            ? 'sorted descending'
                                            : 'sorted ascending'}
                                    </Box>
                                )}
                            </TableSortLabel>
                        ) : (
                            headCell.label
                        )}
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
}

OrderTableHead.propTypes = {
    order: PropTypes.string,
    orderBy: PropTypes.string,
};

export default function OrderTable() {
    const [orderBy, setOrderBy] = useState('email');
    const [order, setOrder] = useState('asc');
    const [page, setPage] = useState(0);
    const [totalUser, setTotaluser] = useState(0);
    const dispatch = useDispatch();
    const { dateRange } = useSelector((state) => state.users);
    const { searchData } = useSelector((state) => state.search);
    const [refetchUser, setRefetchUser] = useState();
    const [statusLoading, setStatusLoading] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [rows, setRows] = useState([]);
    const [pagePerRows, setPagePerRows] = useState(15);
    const [allWorkspaces, setAllWorkspaces] = useState([]);
    const [userId, setUserId] = useState(null);
    const [open, setOpen] = useState(false);
    const [userEmail, setUserEmail] = useState(''); 
    const [getAllWorkspaces] = useGetAllWorkspacesMutation();
    const [statusDisable] = useDisableUserMutation();
    const [statusActive] = useEnableUserMutation();
    const [openAddOns, setOpenAddOns] = useState(false);
    const [getToken, { data: tokenData }] = useLazyGetUserAuthTokenQuery();
    const [openStatus, setOpenStatus] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [anchorEl, setAnchorEl] = useState(null);
    const [name, setName] = useState('Active');
    const [enablePartner] = useEnablePartnerWithSubUsersMutation();
    const [toggleAiSuperSearch] = useTogglePartnerAiSuperSearchMutation();
    const [getAiSuperSearchStatus] = useLazyGetPartnerAiSuperSearchQuery();
    const [aiSuperSearchStatuses, setAiSuperSearchStatuses] = useState({});
    const [openAiSuperSearch, setOpenAiSuperSearch] = useState(false);
    const [selectedPartner, setSelectedPartner] = useState(null);

    const {
        data,
        refetch,
        isLoading: refetchLoader,
    } = useGetAllPartnersQuery({
        sortBy: orderBy,
        page: page + 1,
        limit: pagePerRows,
        order,
        userType: name,
        ...(dateRange?.start && { start: dateRange?.start }),
        ...(dateRange?.end && { end: dateRange?.end }),
        ...(searchData?.length && { search: searchData }),
    });

    const handleChangePage = (_event, newPage) => {
        setPage(newPage);
    };

    const handleClickOpen = async (id, row) => {
        setStatusLoading(true);
        const workspaces = await getAllWorkspaces({
            params: _.pickBy({ id }),
        }).unwrap();
        setAllWorkspaces(workspaces);
        setUserId(id);
        setOpen(true);
        setStatusLoading(false);
        setUserEmail(row.email)
    };
    const handleAddOnsClickOpen = async (id) => {
        setStatusLoading(true);
        const workspaces = await getAllWorkspaces({
            params: _.pickBy({ id }),
        }).unwrap();
        setAllWorkspaces(workspaces);
        setOpenAddOns(true);
        setStatusLoading(false);
        setUserEmail('')
    };

    const toggleHandleClick = async (toggle, id) => {
        try {
            if (toggle) {
                //true
                setStatusLoading(true);
                await statusDisable({
                    userId: id,
                });
                await refetch();
                setStatusLoading(false);
                toast.success('User is deactivated successfully');
            } else {
                //false
                setStatusLoading(true);
                await statusActive({
                    userId: id,
                });
                await refetch();
                setStatusLoading(false);
                toast.success('User is activated successfully');
            }
        } catch (error) {
            setStatusLoading(false);
        }
    };

    const handleClose = () => {
        setUserId(null);
        setOpen(false);
    };

    const handleCloseAddOns = () => {
        setOpenAddOns(false);
    };

    const handleDeleteAction = (deleteId) => {
        setDeleteConformation(true);
        setUserId(deleteId);
    };

    const actionMenuData = [
        {
            name: 'Edit Usage',
            onChange: handleClickOpen,
        },
        {
            name: 'Edit AddOns Plan',
            onChange: handleAddOnsClickOpen,
        }
    ];

    const handleRequestSort = (_event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const handleRowsPerPageChange = (event) => {
        setPagePerRows(event.target.value);
    };

    const onActionMenuClick = async (id) => {
        setRedirect(true);
        await getToken({ id });
    };

    useEffect(() => {
    if (tokenData?.authToken && redirect) {
      setRedirect(false);
      window.open(
        `${process.env.REACT_APP_FRONTEND_URL}/verify?token=${tokenData?.authToken}&skipUpdate=true`,
        '_blank'
      );
    }
  }, [tokenData]);

    useEffect(() => {
        const handleRefetchData = async () => {
            setStatusLoading(true);
            await refetch();
            setStatusLoading(false);
        };

        if (refetchUser) {
            handleRefetchData();
            setRefetchUser(false);
        } else {
            handleRefetchData();
        }
    }, [
        dateRange,
        name,
        page,
        orderBy,
        order,
        searchData?.length > 0,
        refetchUser,
    ]);

    useEffect(() => {
        if (data?.users?.docs?.length) {

            const rows = data?.users?.docs?.map((cur) => {
                return createData(
                    cur.email,
                    cur.name.first + ' ' + cur.name.last,
                    cur.plan,
                    cur.managePlan,
                    cur.warmupTag,
                    cur?.plan?.freeTrialExpiresAt,
                    cur.createdAt,
                    cur.lastLogout,
                    cur.isDeleted,
                    cur.action,
                    cur._id,
                    cur?.EarlyBirdPlan,
                    cur?.isPartner,
                    cur?.isPartnerSubUser, 
                    cur?.workspace,
                    cur?.deletedBy ,
                    cur?.userDeletedDetails
                );
            });
            setRows(rows);
            dispatch(setPartnerUsers(rows));
            setTotaluser(Number(data?.users?.totalDocs) || 0);
            
            rows.forEach(async (row) => {
                if (row.isPartner) {
                    try {
                        const result = await getAiSuperSearchStatus(row.id).unwrap();
                        setAiSuperSearchStatuses(prev => ({
                            ...prev,
                            [row.id]: result?.aiSuperSearchEnabled || false
                        }));
                    } catch (error) {
                        console.error('Error fetching AI Super Search status:', error);
                    }
                }
            });
        } else {
            setTotaluser(0);
        }
    }, [data]);

    if (refetchLoader) {
        return <LoaderCircle />;
    }

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClosePopover = () => {
        setAnchorEl(null);
    };
    const opened = Boolean(anchorEl);
    const id = open ? 'simple-popover' : undefined;

    const onEnablePartner = async (partnerId) => {
        try {
            const { message } = await enablePartner({ partnerId }).unwrap();
            setRefetchUser(false)
            toast.success(message || 'Partner and sub-users enabled successfully');
        } catch (error) {
            toast.error(error?.data?.message || 'Internal Server Error');
        }
    };

    const handleAiSuperSearchToggle = async (partnerId, currentStatus) => {
        try {
            const newStatus = !currentStatus;
            await toggleAiSuperSearch({ partnerId, enabled: newStatus }).unwrap();
            setAiSuperSearchStatuses(prev => ({
                ...prev,
                [partnerId]: newStatus
            }));
            toast.success(`Super Search ${newStatus ? 'enabled' : 'disabled'} successfully`);
        } catch (error) {
            toast.error(error?.data?.message || 'Failed to update AI Super Search setting');
        }
    };

    return (
        <>
            <>
                <Box
                    sx={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: { xs: 'column', sm: 'row' },
                        justifyContent: 'space-between',
                        alignItems: { xs: 'flex-start', sm: 'center' },
                        mr: 3,
                        my: 2,
                        gap: 2
                    }}
                >
                    <Box sx={{ width: { xs: '97%', sm: '30%' } }}>
                        <Search />
                    </Box>
                    <Box sx={{ px: 1 }}>
                        <Box
                            id="outlined-basic"
                            label="Outlined"
                            variant="outlined"
                            onClick={handleClick}
                            sx={{
                                width: 200,
                                height: '40px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                cursor: 'pointer',
                                p: 1,
                                border: '2px solid rgba(33, 111, 237, 0.5)',
                                fontSize: '15px',
                                borderRadius: '12px',
                                color: '#28287B',
                                fontWeight: '600',
                            }}
                        >
                            <Box>{name}</Box>
                            <Box sx={{ display: 'flex' }}>
                                {opened ? <ArrowDropUpIcon /> : <ArrowDropDownIcon />}
                            </Box>
                        </Box>
                    </Box>
                    <Popover
                        sx={{ mt: 0.7 }}
                        id={id}
                        open={opened}
                        anchorEl={anchorEl}
                        onClose={handleClosePopover}
                        anchorOrigin={{
                            vertical: 'bottom',
                            horizontal: 'bottom',
                        }}
                    >
                        <Box sx={{ width: 200, p: 1, gap: 1 }}>
                            <Typography
                                onClick={() => {
                                    handleClosePopover();
                                    setName('Active');
                                    dispatch(setUserType('Active'));
                                }}
                                sx={{
                                    border: '1px solid #E4E4E5',
                                    borderRadius: '10px',
                                    cursor: 'pointer',
                                    textAlign: 'center',
                                    p: 0.5,
                                    mb: 0.3,
                                    '&:hover': {
                                        backgroundColor: '#739fe5',
                                        color: 'white',
                                    },
                                }}
                            >
                                {'Active'}
                            </Typography>
                            <Typography
                                onClick={() => {
                                    handleClosePopover();
                                    setName('Not Active');
                                    dispatch(setUserType('NotActive'));
                                }}
                                sx={{
                                    border: '1px solid #E4E4E5',
                                    borderRadius: '10px',
                                    cursor: 'pointer',
                                    textAlign: 'center',
                                    p: 0.5,
                                    mb: 0.3,
                                    '&:hover': {
                                        backgroundColor: '#739fe5',
                                        color: 'white',
                                    },
                                }}
                            >
                                {'Not Active'}
                            </Typography>
                            <Typography
                                onClick={() => {
                                    handleClosePopover();
                                    setName('All');
                                    dispatch(setUserType('All'));
                                }}
                                sx={{
                                    border: '1px solid #E4E4E5',
                                    borderRadius: '10px',
                                    cursor: 'pointer',
                                    textAlign: 'center',
                                    p: 0.5,
                                    mb: 0.3,
                                    '&:hover': {
                                        backgroundColor: '#739fe5',
                                        color: 'white',
                                    },
                                }}
                            >
                                {'All'}
                            </Typography>
                        </Box>
                    </Popover>
                </Box>
                {statusLoading ? (
                    <LoaderCircle />
                ) : totalUser === 0 ? (
                    <>
                        <Box
                            sx={{
                                width: 1,
                                height: '70vh',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                fontSize: '2rem',
                            }}
                        >
                            No Partner Users Available
                        </Box>
                    </>
                ) : (
                    <>
                        <Box
                            sx={{
                                border: '1 solid #ebebeb',
                                borderRadius: '12',
                                width: { xs: '100%' },
                            }}
                        >
                            <TableContainer
                                sx={{
                                    width: '100%',
                                    overflowx: 'auto',
                                    maxHeight: '100vh', // 80vh
                                    transition: 'box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                                    boxShadow: 'rgb(234, 236, 240) 0 0 1, rgba(29, 41, 57, 0.08) 0 1 2',
                                    borderRadius: '6',
                                    color: 'rgb(16, 24, 40)',
                                    '& td, & th': { whiteSpace: 'nowrap' }
                                }}
                            >
                                <GlobalStyles
                                    styles={{
                                        '*::-webkit-scrollbar': {
                                            width: '8',
                                            height: '8',
                                        },
                                        '*::-webkit-scrollbar-thumb': {
                                            backgroundColor: 'rgb(228, 228, 229)',
                                            borderRadius: '10',
                                            border: '1 solid rgba(0, 0, 0, 0)',
                                        },
                                        '*::-webkit-scrollbar-track': {
                                            borderRadius: '60',
                                            width: '4',
                                            backgroundColor: 'rgb(242, 244, 246)',
                                        },
                                    }}
                                />
                                <Table
                                    aria-labelledby="tableTitle"
                                    sx={{
                                        '& .MuiTableCell-root:first-of-type': {
                                            pl: 2,
                                        },
                                        '& .MuiTableCell-root:last-of-type': {
                                            pr: 3,
                                        },
                                    }}
                                    stickyHeader
                                >
                                    <OrderTableHead
                                        order={order}
                                        orderBy={orderBy}
                                        onRequestSort={handleRequestSort}
                                    />
                                    <TableBody>
                                        {stableSort(rows, getComparator(order, orderBy)).map(
                                            (row, index) => {
                                                const labelId = `enhanced-table-checkbox-${index}`;
                                                return (
                                                    <TableRow
                                                        hover
                                                        role="checkbox"
                                                        sx={{
                                                            '&:last-child td, &:last-child th': {
                                                                border: 0,
                                                            },
                                                        }}
                                                        tabIndex={-1}
                                                        key={row.email}
                                                    >
                                                        <TableCell
                                                            component="th"
                                                            id={labelId}
                                                            scope="row"
                                                            align="left"
                                                        >
                                                            <Link
                                                                color="secondary"
                                                                component={RouterLink}
                                                                to={`/manage/partnerUsers/${row.id}`}
                                                            >
                                                                {row.email}
                                                            </Link>
                                                        </TableCell>
                                                        <TableCell
                                                            sx={{
                                                                pl: '12 !important',
                                                                align: 'left',
                                                            }}
                                                        >
                                                            {row.name}
                                                        </TableCell>
                                                        <PlanSelector row={row} setRefetchUser={setRefetchUser} />
                                                        <TableCell align="center">
                                                            <ActionMenu
                                                                options={actionMenuData}
                                                                actionId={row.id}
                                                                data={row}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {row.freeTrialExpiresAt ? getFormaDate(row.freeTrialExpiresAt) : '-'}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {getFormaDate(row.createdAt)}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            {getFormaDate(row.lastLogout)}
                                                        </TableCell>
                                                        <TableCell align='center'>
                                                                {row.userDeletedDetails.role === "cronjob" ? (
                                                                    <>
                                                                        <span>{row.userDeletedDetails.role}</span>
                                                                        <br />
                                                                        <Button
                                                                            variant="contained"
                                                                            size="small"
                                                                            onClick={() => onEnablePartner(row.id)}
                                                                        >
                                                                            Enable
                                                                        </Button>
                                                                    </>
                                                                ) : row.userDeletedDetails?.name?.first ||
                                                                    row.userDeletedDetails?.name?.last ||
                                                                    row.userDeletedDetails?.email ? (
                                                                    <Tooltip
                                                                        title={
                                                                            <>
                                                                                {row.userDeletedDetails?.name?.first ||
                                                                                    row.userDeletedDetails?.name?.last ? (
                                                                                    <Typography variant="body2">
                                                                                        Name: {row.userDeletedDetails?.name?.first}{" "}
                                                                                        {row.userDeletedDetails?.name?.last}
                                                                                    </Typography>
                                                                                ) : null}
                                                                                {row.userDeletedDetails?.email ? (
                                                                                    <Typography variant="body2">
                                                                                        Email: {row.userDeletedDetails?.email}
                                                                                    </Typography>
                                                                                ) : null}
                                                                            </>
                                                                        }
                                                                    >
                                                                        <span>{row.userDeletedDetails.role || "-"}</span>
                                                                    </Tooltip>
                                                                ) : (
                                                                    '-'
                                                                )}
                                                        </TableCell>
                                                        <TableCell align="left">
                                                            <CustomCheckbox
                                                                size={'small'}
                                                                checked={!row.status}
                                                                onClick={() => {
                                                                    setSelectedUser(row);
                                                                    setOpenStatus(true);
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <CustomCheckbox
                                                                size={'small'}
                                                                checked={aiSuperSearchStatuses[row.id] || false}
                                                                onClick={() => {
                                                                    setSelectedPartner(row);
                                                                    setOpenAiSuperSearch(true);
                                                                }}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <ChangePassword id={row.id} email={row.email} />
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Button
                                                                type="button"
                                                                onClick={() => {
                                                                    onActionMenuClick(row.id);
                                                                }}
                                                                sx={{
                                                                    backgroundColor: '#216fed', //'#1890ff'
                                                                    color: '#ffffff',
                                                                    border: 'none',
                                                                    padding: '4 12',
                                                                    fontSize: '14',
                                                                    cursor: 'pointer',
                                                                    boxShadow: '0 4 8 rgba(0, 0, 0, 0.1)',
                                                                    transition: 'box-shadow 0.3s',
                                                                    '&:hover': {
                                                                        boxShadow: '0 6 12 rgba(0, 0, 0, 0.15)',
                                                                        backgroundColor: '#216fed',
                                                                    },
                                                                }}
                                                            >
                                                                Manage
                                                            </Button>
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            <Button
                                                                type="button"
                                                                disabled
                                                                onClick={() => {
                                                                    handleDeleteAction(row.id);
                                                                }}
                                                                sx={{
                                                                    backgroundColor: '#ff0000', //'#1890ff'
                                                                    color: '#ffffff',
                                                                    border: 'none',
                                                                    padding: '4 12',
                                                                    fontSize: '14',
                                                                    cursor: 'pointer',
                                                                    boxShadow: '0 4 8 rgba(0, 0, 0, 0.1)',
                                                                    transition: 'box-shadow 0.3s',
                                                                    '&:hover': {
                                                                        boxShadow: '0 6 12 rgba(0, 0, 0, 0.15)',
                                                                        backgroundColor: '#ff0000',
                                                                    },
                                                                }}
                                                            >
                                                                Delete
                                                            </Button>
                                                        </TableCell>
                                                    </TableRow>
                                                );
                                            }
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            <TablePagination
                                sx={{
                                    border: '1 solid #f0f0f0',
                                    borderRadius: 2,
                                }}
                                component="div"
                                rowsPerPageOptions={[15, 25, 50, 100]}
                                rowsPerPage={pagePerRows}
                                onRowsPerPageChange={handleRowsPerPageChange}
                                count={totalUser}
                                page={page}
                                onPageChange={handleChangePage}
                            />
                        </Box>
                    </>
                )}
            </>
            <PlanSetting userId={userId} onClose={handleClose} open={open} allWorkspaces={allWorkspaces} isPartnerAccount={true} email={userEmail} />
            <AddOnSettingModel 
                userId={userId} 
                onClose={handleCloseAddOns} 
                open={openAddOns} 
                allWorkspaces={allWorkspaces} 
            />
            <ConfirmStatusDialog
                open={openStatus}
                title="Confirmation"
                content={`Are you sure you want to ${!selectedUser?.status ? "deactivate" : "activate"} this user?`}
                onClose={() => setOpenStatus(false)}
                onConfirm={() => {
                    toggleHandleClick(!selectedUser.status, selectedUser.id);
                    setOpenStatus(false);
                }}
            />
            <ConfirmStatusDialog
                open={openAiSuperSearch}
                title="Super Search Confirmation"
                content={`Are you sure you want to ${aiSuperSearchStatuses[selectedPartner?.id] ? "disable" : "enable"} Super Search for this partner?`}
                onClose={() => setOpenAiSuperSearch(false)}
                onConfirm={() => {
                    handleAiSuperSearchToggle(selectedPartner.id, aiSuperSearchStatuses[selectedPartner.id]);
                    setOpenAiSuperSearch(false);
                }}
            />
        </>
    );
}
